export const environment = {
  production: false,
  s3Url: 'https://vw-dev-sitesbuilder.eu-west-1.staticresources.3ddvfactory.com',
  apiSiteUrl: 'https://dev-sitesbuilder-eu-south-2.service.3ddvapis.com',
};
